import { Props } from './types';
import {
  EntryOptions,
  PropertyDefinition,
  PropertyMappingType,
} from 'app/library/layout-builder';
import { MetaTypeEnum } from 'app/shared';
import { CmsReactComponent } from '../CmsReactComponent';

export class ListDefinitions extends CmsReactComponent<Props> {
  static schemaName = 'list';

  static propertyDefinitions: PropertyDefinition[] = [
    {
      name: 'data',
      text: 'Öğeler',
      mapping: {
        type: PropertyMappingType.ArrayData,
        keys: [
          {
            name: 'title',
            mapping: {
              type: PropertyMappingType.String,
            },
            text: 'Başlık',
          },
          {
            name: 'url',
            mapping: {
              type: PropertyMappingType.LinkWizard,
            },
            text: 'Link',
          },
          {
            name: 'color',
            mapping: {
              type: PropertyMappingType.Color,
            },
            text: 'Renk',
            default: '#000000',
          },
        ],
      },
    },
  ];

  static options: EntryOptions = {
    mappingFields: [
      {
        name: 'title',
        text: 'Başlık',
        types: [MetaTypeEnum.Text],
      },
      {
        name: 'url',
        text: 'Link',
        types: [MetaTypeEnum.Link, MetaTypeEnum.Text],
      },
    ],
  };
}
